(function () {
  "use strict";

  var DATA_FILES = [
    window.__materialDataUrl1,
    window.__materialDataUrl2,
    window.__materialDataUrl3
  ];

  var materialMap = null;
  var loadingPromise = null;

  function loadMaterialMap() {
    if (loadingPromise) return loadingPromise;
    loadingPromise = Promise.all(
      DATA_FILES.filter(Boolean).map(function (url) {
        return fetch(url, { credentials: "omit" })
          .then(function (r) { return r.ok ? r.json() : {}; })
          .catch(function () { return {}; });
      })
    ).then(function (parts) {
      var merged = {};
      parts.forEach(function (part) {
        for (var k in part) {
          if (Object.prototype.hasOwnProperty.call(part, k)) merged[k] = part[k];
        }
      });
      materialMap = merged;
      return merged;
    });
    return loadingPromise;
  }

  function injectInto(form) {
    if (!form || form.__materialInjected) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;
    if (form.querySelector('input[name="properties[Material]"]')) {
      form.__materialInjected = true;
      return;
    }
    var value = materialMap && materialMap[idInput.value];
    if (!value) return;
    var hidden = document.createElement("input");
    hidden.type = "hidden";
    hidden.name = "properties[Material]";
    hidden.value = value;
    form.appendChild(hidden);
    form.__materialInjected = true;
  }

  function scan(root) {
    if (!materialMap) return;
    var scope = root || document;
    var forms = scope.querySelectorAll ? scope.querySelectorAll('form[action*="/cart/add"]') : [];
    for (var i = 0; i < forms.length; i++) injectInto(forms[i]);
    if (scope.matches && scope.matches('form[action*="/cart/add"]')) injectInto(scope);
  }

  function watchVariantChanges() {
    document.addEventListener("change", function (e) {
      if (e.target && e.target.name === "id") {
        var form = e.target.closest && e.target.closest('form[action*="/cart/add"]');
        if (form) {
          form.__materialInjected = false;
          var existing = form.querySelector('input[name="properties[Material]"]');
          if (existing) existing.parentNode.removeChild(existing);
          injectInto(form);
        }
      }
    }, true);
  }

  function init() {
    loadMaterialMap().then(function () {
      scan(document);

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (m) {
          m.addedNodes && m.addedNodes.forEach(function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });

      // Re-scan just before any add-to-cart submit as a final safety net
      // (covers forms whose variant id changed via JS without a 'change' event).
      document.addEventListener(
        "submit",
        function (e) {
          var form = e.target;
          if (form && form.matches && form.matches('form[action*="/cart/add"]')) {
            injectInto(form);
          }
        },
        true
      );
    });

    watchVariantChanges();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
